"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transitionProps = void 0;
const transitionProps = exports.transitionProps = {
  timeout: 0
};
